module.exports = __webpack_public_path__ + "img/mockup-mobile-aymeric.fa01e423.png";